import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	runbooksPanelTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.title',
		defaultMessage: 'Runbooks',
		description: 'Title for the runbooks side panel',
	},
	runbooksPanelCloseButtonAriaLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.close-button-aria-label',
		defaultMessage: 'Close runbooks',
		description: 'Aria label for the close button in the runbooks panel',
	},
	runbooksPanelLoadingRunbooks: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.loading-runbooks',
		defaultMessage: 'Loading runbooks…',
		description: 'Loading message while runbook summaries are fetched',
	},
	runbooksPanelLoadingRunbookDetails: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.loading-runbook-details',
		defaultMessage: 'Loading runbook details…',
		description: 'Loading message while runbook details are fetched',
	},
	runbooksPanelErrorMessage: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.error-message',
		defaultMessage: 'We couldn’t load runbooks for this ticket.',
		description: 'Error message when runbook summaries fail to load',
	},
	runbooksPanelDetailErrorMessage: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.detail-error-message',
		defaultMessage: 'We couldn’t load this runbook.',
		description: 'Error message when runbook details fail to load',
	},
	runbooksPanelRetryButton: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.retry-button',
		defaultMessage: 'Retry',
		description: 'Button label to retry loading runbooks or runbook details',
	},
	runbooksPanelEmptyMessage: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.empty-message',
		defaultMessage: 'No runbooks are available for this ticket.',
		description: 'Empty state message when a ticket has no runbooks',
	},
	runbooksPanelExpandRunbookLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.expand-runbook-label',
		defaultMessage: 'Expand {title}',
		description: 'Accessible label for expanding a runbook card',
	},
	runbooksPanelCollapseRunbookLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.collapse-runbook-label',
		defaultMessage: 'Collapse {title}',
		description: 'Accessible label for collapsing a runbook card',
	},
	runbooksPanelNextReviewLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.next-review-label',
		defaultMessage: 'Next review',
		description: 'Label for the runbook next review date metadata',
	},
	runbooksPanelStepsTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.steps-title',
		defaultMessage: 'Steps',
		description: 'Title for the steps list inside an expanded runbook',
	},
	runbooksPanelOpenRunbookLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.open-runbook-label',
		defaultMessage: 'Open {title} in Marathon',
		description: 'Accessible label for the link button that opens a runbook in Marathon',
	},
	runbooksPanelProductLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.product-label',
		defaultMessage: 'Product',
		description: 'Label for the runbook product metadata',
	},
	runbooksPanelJiraProductName: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.jira-product-name',
		defaultMessage: 'Jira',
		description: 'Runbook product name for Jira',
	},
	runbooksPanelConfluenceProductName: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.confluence-product-name',
		defaultMessage: 'Confluence',
		description: 'Runbook product name for Confluence',
	},
	runbooksPanelResponsibleLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.responsible-label',
		defaultMessage: 'Responsible',
		description: 'Label for the runbook step responsible metadata',
	},
	runbooksPanelStepDoneIconLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-done-icon-label',
		defaultMessage: 'Done',
		description: 'Accessible label for a completed runbook step icon',
	},
	runbooksPanelStepRiskIconLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-risk-icon-label',
		defaultMessage: 'At risk',
		description: 'Accessible label for a runbook step risk icon',
	},
	runbooksPanelStepDisabledIconLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-disabled-icon-label',
		defaultMessage: 'Disabled',
		description: 'Accessible label for a disabled runbook step icon',
	},
	runbooksPanelStepActionsMenuLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-actions-menu-label',
		defaultMessage: 'More step actions',
		description: 'Accessible label for the runbook step actions menu',
	},
	runbooksPanelStepEnableAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-enable-action',
		defaultMessage: 'Enable step',
		description: 'Menu action to enable a runbook step',
	},
	runbooksPanelStepDisableAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-disable-action',
		defaultMessage: 'Disable step',
		description: 'Menu action to disable a runbook step',
	},
	runbooksPanelStepFlagAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-flag-action',
		defaultMessage: 'Flag step',
		description: 'Menu action to flag a runbook step as at risk',
	},
	runbooksPanelStepUnflagAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-unflag-action',
		defaultMessage: 'Unflag step',
		description: 'Menu action to remove the risk flag from a runbook step',
	},
	runbooksPanelStepMarkCompleteAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-mark-complete-action',
		defaultMessage: 'Mark complete',
		description: 'Menu action to mark a runbook step complete',
	},
	runbooksPanelStepMarkIncompleteAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-mark-incomplete-action',
		defaultMessage: 'Mark incomplete',
		description: 'Menu action to mark a runbook step incomplete',
	},
	runbooksPanelStepActionErrorFlagTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-action-error-flag-title',
		defaultMessage: 'We couldn’t update this step',
		description: 'Title for the runbook step mutation failure flag',
	},
	runbooksPanelStepActionErrorFlagDescription: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-action-error-flag-description',
		defaultMessage: 'Try again or open the runbook in Marathon.',
		description: 'Description for the runbook step mutation failure flag',
	},
	runbooksPanelStepActionRetryAction: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.step-action-retry-action',
		defaultMessage: 'Retry',
		description: 'Action label to retry a failed runbook step mutation',
	},
	runbooksPanelOtherPhaseLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.other-phase-label',
		defaultMessage: 'Other',
		description: 'Fallback phase group label for runbook steps without a phase',
	},
	runbooksPanelModalCancelButton: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.modal-cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for the cancel button shared by the runbook step action modals',
	},
	runbooksPanelNoteModalTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-title',
		defaultMessage: 'Mark step complete',
		description:
			'Title for the modal that captures a required note before completing a runbook step',
	},
	runbooksPanelNoteModalCloseButtonAriaLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-close-button-aria-label',
		defaultMessage: 'Close',
		description: 'Aria label for the close button in the runbook step note modal',
	},
	runbooksPanelNoteModalDescription: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-description',
		defaultMessage: 'This step requires a note before it can be marked complete.',
		description: 'Helper text explaining that a note is required to complete the step',
	},
	runbooksPanelNoteModalEditorLabel: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-editor-label',
		defaultMessage: 'Runbook step completion note',
		description: 'Accessible label for the note editor in the runbook step note modal',
	},
	runbooksPanelNoteModalEditorPlaceholder: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-editor-placeholder',
		defaultMessage: 'Add a note…',
		description: 'Placeholder text for the note editor in the runbook step note modal',
	},
	runbooksPanelNoteModalEmptyError: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-empty-error',
		defaultMessage: 'A note is required to mark this step complete.',
		description: 'Validation error shown when the user tries to complete a step without a note',
	},
	runbooksPanelNoteModalConfirmButton: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.note-modal-confirm-button',
		defaultMessage: 'Mark complete',
		description: 'Label for the confirm button in the runbook step note modal',
	},
	runbooksPanelCompleteModalTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.complete-modal-title',
		defaultMessage: 'Mark step complete',
		description: 'Title for the confirmation modal shown before completing a runbook step',
	},
	runbooksPanelCompleteModalBody: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.complete-modal-body',
		defaultMessage:
			'Are you sure you would like to mark the <stepName>{title}</stepName> step complete?',
		description: 'Body text for the confirmation modal shown before completing a runbook step',
	},
	runbooksPanelCompleteModalConfirmButton: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.complete-modal-confirm-button',
		defaultMessage: 'Mark complete',
		description: 'Label for the confirm button in the complete runbook step confirmation modal',
	},
	runbooksPanelDisableModalTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.disable-modal-title',
		defaultMessage: 'Disable step',
		description: 'Title for the confirmation modal shown before disabling a runbook step',
	},
	runbooksPanelEnableModalTitle: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.enable-modal-title',
		defaultMessage: 'Enable step',
		description: 'Title for the confirmation modal shown before enabling a runbook step',
	},
	runbooksPanelDisableModalBody: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.disable-modal-body',
		defaultMessage: 'Are you sure you would like to disable the <stepName>{title}</stepName> step?',
		description: 'Body text for the confirmation modal shown before disabling a runbook step',
	},
	runbooksPanelEnableModalBody: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.enable-modal-body',
		defaultMessage: 'Are you sure you would like to enable the <stepName>{title}</stepName> step?',
		description: 'Body text for the confirmation modal shown before enabling a runbook step',
	},
	runbooksPanelDisableModalConfirmButton: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.disable-modal-confirm-button',
		defaultMessage: 'Disable',
		description: 'Label for the confirm button in the disable runbook step confirmation modal',
	},
	runbooksPanelEnableModalConfirmButton: {
		id: 'fastshift.migration-tickets-page.runbooks-panel.enable-modal-confirm-button',
		defaultMessage: 'Enable',
		description: 'Label for the confirm button in the enable runbook step confirmation modal',
	},
});
